import ProtectedAdminRoute from "@/utils/ProtectedAdminRoute";
import AdminDashboardLayout from "@/components/admin/dashboard";

export const adminRoutes = [
  {
    element: <ProtectedAdminRoute />,
    children: [{ path: "/admin/*", element: <AdminDashboardLayout /> }],
  },
];
